import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js"
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';

//services
import { formateDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";

export default function ExtratoRoyalties({history,royaltieId}) {
  
  const [logo] = React.useState(require("assets/img/logologin.png"));

  const [notification, setNotification] = React.useState({
      show:false,
      color:'info',
      message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
      show:true,
      color:color,
      message:message      
      });
      setTimeout(function() {
      setNotification({show:false});
      }, 6000);       
  };

  const location = useLocation();  
  const [showBackFechamento,setshowBackFechamento] = React.useState(false);
  useEffect(() => {

    let idRoy = null;
    if(location.state)
    {
      idRoy = location.state.royaltieId;
      setshowBackFechamento(true);
    }
    else if(royaltieId)
    {
      idRoy = royaltieId;
      setshowBackFechamento(false);
    }
    
    if(idRoy)
      loadRelatorio(idRoy); 
    else
      showNotification('Não é possivel realizar o carregamento dos dados do relatório, sem o recebimento dos parametros.','danger'); 

  }, [royaltieId]);

  const [loading,setLoading] = React.useState(false);
  const [dadosRelatorio,setdadosRelatorio] = React.useState({
  valorFaturamentoTotal: "",
  valorFaturamentoPacotesServicos: "",
  valorFaturamentoProdutos: "",
  valorCartao: "",
  valorRepasseSliptCartaoClinica: "",
  valorCreditosAVista: "",
  valorCreditosFechamento: "",
  valorDebitos: "",
  valorAPagar: "",
  totalReceberAVista: ""
  });
  const [detalhevendas,setdetalhevendas] = React.useState([]);
  const [detalhecreditos,setdetalhecreditos] = React.useState([]);
  const [detalhepedidos,setdetalhepedidos] = React.useState([]);
  const [detalhedebitos,setdetalhedebitos] = React.useState([]);

  const loadRelatorio = (royaltieId) =>{        
      const endPoint = "royalties/getExtratoRoyaltie/" + royaltieId;
      setLoading(true);
      UseGetApiSimple(endPoint,0).then(result=>{         
          if(result.status !== 200)
          {                                     
              showNotification(result.message,'danger');
              setLoading(false);
              return false; 
          }
          
          setdadosRelatorio(result.data); 
          loadDetalhamento(result.data.detalhamentoRoyaltie);
          
          setLoading(false);
          return true;                
      });
  }  

  const loadDetalhamento = (result) =>{
    if(result)
    {
      let lstvendas = result.filter(obj => {
        return obj.tipo === 0;
      });
      setdetalhevendas(lstvendas); 
      
      let lstcreditos = result.filter(obj => {
        return obj.tipo === 1;
      });
      setdetalhecreditos(lstcreditos); 
      
      let lstpedidos = result.filter(obj => {
        return obj.tipo === 2;
      });
      setdetalhepedidos(lstpedidos); 

      let lstdebitos = result.filter(obj => {
        return obj.tipo === 3;
      });
      setdetalhedebitos(lstdebitos); 
    } 
  };

  const [listaDetalheItem, setListaDetalheItem] = React.useState([]);
  const loadDetalheProdutoServicoPacote = (result) => {
    if (result)
    {
      let lstDetalheItem = result;
      setListaDetalheItem(lstDetalheItem);
    }
  };

  const back = () =>{
    if(location.state)
    {
      let from = location.state.from;
      if(from === 'clinic')      
        history.push('/adminclinic/fechamentoroyalties');
      else
        history.push('/adminmatriz/fechamentoroyalties');
    }
  }
  
  return (
    <div style={{marginTop:'0px !important', paddingTop:'0px !important'}}>
        
      {loading && <div className="loadingDash" style={{height:'220px'}}><CircularProgress size={40} /></div>}
          
      {!loading &&
        <GridContainer>        

          <GridItem xs={12} sm={12} md={12}>          
            <center className="no-print">
              {showBackFechamento && <Button 
              onClick={() => back()}
              >
              Voltar
              </Button>}
              <Button  
              color="info"
              onClick={() => window.print()}
              >
              Imprimir
              </Button>
            </center>         

            <div className="allowPrint"
              style={{color:'black', maxWidth:'900px',margin:'0 auto',border:'1px solid rgb(206, 206, 206)',background:'white',padding:'20px 30px'}}>              
            <div >
              
              <div style={{fontSize:'1.2em'}}>
                <img src={logo}/>
                <div style={{float:'right', textAlign:'right'}}>
                  <h3> {dadosRelatorio.estabelecimentoDescricao} </h3>
                  <h4>Referente: {dadosRelatorio.mesAno} </h4>
                </div>
                <div style={{clear:'both'}}></div>
              </div>

              <hr className='lineGrayDashed' />

              <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                <h3 syle={{marginTop:'0px!important'}}>Resumo do Extrato</h3>
                <GridContainer style={{background:'#f7f7f7'}}>
                  <GridItem xs={12} sm={6} md={6}>                 
                    <h6> <b>FATURAMENTO <small>(Total)</small>:</b> {transformValueFloattoFormated(dadosRelatorio.valorFaturamentoTotal)}  </h6>
                    <h6> <b>FATURAMENTO <small>(Pacote + Serviço)</small>:</b> {transformValueFloattoFormated(dadosRelatorio.valorFaturamentoPacotesServicos)} </h6>
                    <h6> <b>FATURAMENTO <small>(Produtos)</small>:</b> {transformValueFloattoFormated(dadosRelatorio.valorFaturamentoProdutos)} </h6>
                    <h6> <b>ROYALTIES:</b> {transformValueFloattoFormated(dadosRelatorio.valorRoyalties)} </h6>
                    <h6> <b>MÉDIA DE PARCELAS:</b> {dadosRelatorio.mediaParcelas} </h6>
                    <h6 style={{ marginBottom: '0' }}>
                      <b>TOTAL CARTÃO:</b> {transformValueFloattoFormated(dadosRelatorio.valorCartao)}
                    </h6>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <h6><b>REPASSE SPLIT CARTÃO CLÍNICA:</b> {transformValueFloattoFormated(dadosRelatorio.valorRepasseSliptCartaoClinica)}  </h6>
                    <h6><b>CRÉDITOS A VISTA:</b> {transformValueFloattoFormated(dadosRelatorio.valorCreditosAVista)}  </h6>
                    <h6><b>CRÉDITOS DO FECHAMENTO:</b> {transformValueFloattoFormated(dadosRelatorio.valorCreditosFechamento)}  </h6>
                    <h6><b>TOTAL DÉBITOS:</b> {transformValueFloattoFormated(dadosRelatorio.valorDebitos)} </h6>
                    <h6 style={{ marginBottom: '0' }}>
                      <b>{ dadosRelatorio.valorAPagar >= 0 ? "TOTAL A RECEBER" : "TOTAL A PAGAR"}:</b> {transformValueFloattoFormated(dadosRelatorio.valorAPagar)} 
                    </h6>
                    {dadosRelatorio.totalReceberAVista > 0 &&
                      <h6> <b> RECEBER A VISTA: </b> {transformValueFloattoFormated(dadosRelatorio.totalReceberAVista)} </h6>
                    }
                  </GridItem>
                </GridContainer>
              </div>

              <hr className='lineGrayDashed' />

              <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                <h4>Detalhamento de Vendas</h4>
                {(detalhevendas && detalhevendas.length > 0)
                  && 
                  <table className='table-print min-w-full border border-neutral-200'>
                    <thead class='border-b border-neutral-200'>
                      <tr>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                      </tr>
                    </thead>
                  <tbody>                   
                      {detalhevendas.map(item => (
                        <tr key={item.id} class='border-b border-neutral-200'>
                            <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'center'}}>{formateDate(item.data)}</td>
                            <td className='border-e border-neutral-200 px-3 py-2 pl-2'>{item.historico}</td>
                            <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.credito)}</td>
                            <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.debito)}</td>
                            <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.saldo)}</td>
                        </tr>
                    ))}                     
                  </tbody>
                  </table> 
                } 
                
                {(!detalhevendas || detalhevendas.length === 0) &&
                  <div> Não contém registros </div>
                }             
              </div>

              <hr className='lineGrayDashed' />

              <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                <h4>Detalhamento de Créditos Diversos</h4>
                {(detalhecreditos && detalhecreditos.length > 0)
                  && 
                  <table className='table-print min-w-full border border-neutral-200'>
                    <thead class='border-b border-neutral-200'>
                      <tr>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                      </tr>
                    </thead>
                    <tbody>                   
                        {detalhecreditos.map(item => (
                          <tr key={item.id} class='border-b border-neutral-200'>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'center'}}>{formateDate(item.data)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2'>{item.historico}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.credito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.debito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.saldo)}</td>
                          </tr>
                      ))}
                    </tbody>
                  </table> 
                } 
                
                {(!detalhecreditos || detalhecreditos.length === 0) &&
                  <div> Não contém registros </div>
                }   
                                
              </div>

              <hr className='lineGrayDashed' />

              <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                <h4>Detalhamento de Compras</h4>
                {(detalhepedidos && detalhepedidos.length > 0)
                  && 
                  <table className='table-print min-w-full border border-neutral-200'>
                    <thead class='border-b border-neutral-200'>
                      <tr>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                      </tr>
                    </thead>
                    <tbody>                   
                        {detalhepedidos.map(item => (
                          <tr key={item.id} class='border-b border-neutral-200'>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'center'}}>{formateDate(item.data)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2'>{item.historico}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.credito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.debito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.saldo)}</td>
                          </tr>
                      ))}
                    </tbody>
                  </table> 
                } 
                
                {(!detalhepedidos || detalhepedidos.length === 0) &&
                  <div> Não contém registros </div>
                }
              
              </div>

              <hr className='lineGrayDashed' />

              <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                <h4>Detalhamento de Débitos Diversos</h4>
                {(detalhedebitos && detalhedebitos.length > 0)
                  && 
                  <table className='table-print min-w-full border border-neutral-200'>
                    <thead class='border-b border-neutral-200'>
                      <tr>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                      </tr>
                    </thead>
                    <tbody>                   
                        {detalhedebitos.map(item => (
                          <tr key={item.id} class='border-b border-neutral-200'>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'center'}}>{formateDate(item.data)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2'>{item.historico}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.credito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.debito)}</td>
                              <td className='border-e border-neutral-200 px-3 py-2 pl-2' style={{textAlign:'right'}}>{transformValueFloattoFormated(item.saldo)}</td>
                          </tr>
                      ))}
                    </tbody>
                  </table> 
                } 
                
                {(!detalhedebitos || detalhedebitos.length === 0) &&
                  <div> Não contém registros </div>
                }              
              </div>

            </div>              
              
            </div>                

          </GridItem>
        
        </GridContainer>   
      }
          
      <br />

      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification(false)}
        close
        />     
          
    </div>
  );
}